/*******************************************************************************
/*******************************************************************************
* ReturnItemsRunReceipt */
/**
 * Creates a data object constructor by setting default values and functions on
 * the prototype. The data will be initialized from the `source`.
 *******************************************************************************/
/* @ngInject */ export function ReturnItemsRunReceipt(Data, SERVER) {
  /*****************************************************************************
   * Constructor
   *****************************************************************************/
  Data.Receipt = function (source) {
    return Object.assign(Object.create(Data.Receipt.prototype), source || {});
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  Data.Receipt.prototype = {
    receiptItems: [],
    paymentItems: [],
    creditAmount: NaN,

    /** Separates the subitems of a kit into individual items, and returns
        all items (without the kit) together as a single dimensional list. This
        is currently only used by returnItems. */
    get flatItemList() {
      var list = [];

      var includeItem = function (item) {
        return (
          item.type === SERVER.BooksDBConstants.LIT_ITEM_SALE ||
          item.type === SERVER.BooksDBConstants.LIT_ITEM_ORDER ||
          item.type === SERVER.BooksDBConstants.LIT_SERVICE_FEE_CREDIT ||
          item.type === SERVER.BooksDBConstants.LIT_STUDENT_FUNDS_PURCHASE ||
          item.type === SERVER.BooksDBConstants.LIT_STUDENT_FUNDS_RETURN ||
          item.type === SERVER.BooksDBConstants.LIT_DONATION_PURCHASE ||
          item.type === SERVER.BooksDBConstants.LIT_DONATION_RETURN ||
          /*-----------------------------------------------------------*/
          /* Internal receivable payments (cash/check paid directly    */
          /* against a charge or fine) - returnable the same way as a  */
          /* student funds purchase or convenience fee. Destiny fine   */
          /* payments carry a distinct subType (LIS_DESTINY_FINE_PAYMENT) */
          /* and are structurally excluded by this check - the server  */
          /* refuses them too (ReceivableRefund.validate()).           */
          /*-----------------------------------------------------------*/
          (item.type === SERVER.BooksDBConstants.LIT_RECEIVABLE_CREDIT &&
            (item.subType === SERVER.BooksDBConstants.LIS_ITEM_PAYMENT ||
              item.subType === SERVER.BooksDBConstants.LIS_FINE_PAYMENT))
        );
      };

      if (this.receiptItems)
        this.receiptItems.forEach(function (ti) {
          if (ti.subType === SERVER.BooksDBConstants.LIS_ITEM_GROUP)
            (ti.subItems || []).forEach(function (si) {
              if (includeItem(si)) list.push(si);
            });
          else if (includeItem(ti)) list.push(ti);
        });

      return list;
    }
  };
}
